'use strict';

import analytics from '../utils/analytics';
import cookie from '../storage/cookie';
import foundationLoader from '../utils/foundation-loader';
import logger from '../utils/logger';
import vendorConsents from '../utils/vendor-consents';

const classNames = {
	newsletterSignup: 'newsletter-signup',
	newsletterSignupSubmit: 'newsletter-signup__submit',
	completeButton: 'complete-button',
	errorLabel: 'error-label',
	input: 'input',
	button: 'button',
	promptLabel: 'prompt-label',
	successLabel: 'success-label',
};

const modifierNames = {
	submitting: 'submitting'
};

const trackingCategory = 'NTG newsletter';

function initVisibility() {
	let newsletterSignupCookie = cookie.getCookie(cookie.names.newsletterSignup);

	if (!newsletterSignupCookie) {
		newsletterSignupCookie = {
			pageViewCount: 1,
			interacted: false
		};
	} else {
		newsletterSignupCookie.pageViewCount++;
	}

	cookie.setCookie(cookie.names.newsletterSignup, newsletterSignupCookie);

	const pageViewThreshold = $('#newsletterSignup').data('page-view-threshold');

	if (newsletterSignupCookie.pageViewCount >= pageViewThreshold && !newsletterSignupCookie.interacted) {
		$.findByBem(classNames.newsletterSignup).show();
		analytics.trackEvent(trackingCategory, 'Load', window.location.href);
	}
}

function initCloseButton() {
	$.findByBem(classNames.newsletterSignup, 'close').on('click', function () {
		$.findByBem(classNames.newsletterSignup).hide();
		setCookieInteracted();
	});

	$.findByBem(classNames.newsletterSignup, classNames.completeButton).on('click', function () {
		$.findByBem(classNames.newsletterSignup).hide();
	});
}

function send(target) {
	const $formElements = $(target).find('input');

	analytics.trackEvent(trackingCategory, 'newsletter signup', 'success');

	$.findByBem(classNames.newsletterSignupSubmit, classNames.errorLabel).hide();
	$.findByBem(classNames.newsletterSignupSubmit, classNames.input).attr('disabled', true);
	$.findByBem(classNames.newsletterSignupSubmit, classNames.button)
		.attr('disabled', true)
		.html('Submitting&hellip;')
		.addBemClass(classNames.newsletterSignupSubmit, classNames.button, modifierNames.submitting);

	const userEmail = $formElements.filter('#emailInput').val()

	$.ajax({
		method: 'GET',
		url: `/api/newsletter-signup/subscribe/${userEmail}/`,
		success: function (resultData) {
			$.findByBem(classNames.newsletterSignupSubmit, classNames.button).hide();
			$.findByBem(classNames.newsletterSignupSubmit, classNames.promptLabel).hide();
			$.findByBem(classNames.newsletterSignup, classNames.completeButton).css('display', 'block');
			$.findByBem(classNames.newsletterSignupSubmit, classNames.successLabel).show();
			$.findByBem(classNames.newsletterSignupSubmit, classNames.input).attr('disabled', 'true');
			setCookieInteracted(userEmail, resultData);
		},
		error: function (xhr, status, err) {
			$.findByBem(classNames.newsletterSignupSubmit, classNames.errorLabel).css('display', 'block').insertAfter(err);
			$.findByBem(classNames.newsletterSignupSubmit, classNames.input).attr('disabled', false);
			$.findByBem(classNames.newsletterSignupSubmit, classNames.button)
				.attr('disabled', false)
				.html('Submit')
				.removeBemClass(classNames.newsletterSignupSubmit, classNames.button, modifierNames.submitting);
		}
	});
}

function setCookieInteracted(userEmail, newsletterSubscribeResult) {
	const  newsletterSignupCookie = cookie.getCookie(cookie.names.newsletterSignup);

	if (newsletterSignupCookie) {
		newsletterSignupCookie.interacted = true;

		cookie.setCookie(cookie.names.newsletterSignup, newsletterSignupCookie);

		if (window.permutive && newsletterSubscribeResult) {
			window.permutive.identify([
				{
					id: newsletterSubscribeResult.userSaltedEmailHash,
					tag: 'bauer_id',
					priority: 0
				},
				{
					id: newsletterSubscribeResult.userEmailHash,
					tag: 'email_sha256',
					priority: 1
				}
			]);

			setPermutiveCookie(newsletterSubscribeResult);
		}
	}
}

function setPermutiveCookie(newsletterSubscribeResult) {
	let permutiveUserEmailHashCookie = cookie.getCookie(cookie.names.permutiveUserEmailHash);

	if(!permutiveUserEmailHashCookie)
	{
		permutiveUserEmailHashCookie = {
			permutiveUserEmailHashData: {
				userEmailHash: newsletterSubscribeResult.userEmailHash,
				userSaltedEmailHash: newsletterSubscribeResult.userSaltedEmailHash
			},
			userKnown: true
		};

		cookie.setCookie(cookie.names.permutiveUserEmailHash, permutiveUserEmailHashCookie);
	}
}

function initNewsletter() {
	vendorConsents.onRetrieveVendorAndPurposeConsents(function () {
		initVisibility();
		initCloseButton();

		$(window).on('load', function () {
			$(document).on('formvalid.zf.abide', function (e, target) {
				send(target);
			}).on('submit', function (e) {
				e.preventDefault();
			});
		});
	}, function () {
		cookie.deleteCookie('newsletter-signup');
		logger.info('Did not initialise newsletter on completed user action: Insufficient consent');
	});
}

export default {

	init: function () {
		foundationLoader.addPlugins(foundationLoader.PLUGINS.ABIDE);

		this.initForm();
	},

	initForm: function () {
		vendorConsents.addTcfApiHandler(vendorConsents.eventNames.userActionComplete, function () {
			initNewsletter();
		});

		vendorConsents.addTcfApiHandler(vendorConsents.eventNames.subsequentPageLoad, function () {
			initNewsletter();
		});
	}
}